"use client";

import { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { ContactBlockComponent } from "@/components/ContactBlock/ContactBlock.builder";
import { getBuilderModelName } from "@/libs/builder/tools/getBuilderModelName";

export const ContactDetailsName = "Footer ContactDetails";

export const ContactDetailsComponent: RegisteredComponent = {
  name: ContactDetailsName,
  models: [getBuilderModelName("footer")],
  canHaveChildren: true,
  component: dynamic(
    async () =>
      (await import("@jti/ui/eva-components/Footer/components/ContactDetails"))
        .ContactDetails
  ),
  inputs: [
    {
      name: "title",
      type: "string",
      defaultValue: "",
    },
    {
      name: "subTitle",
      type: "string",
    },
    {
      name: "text",
      type: "string",
    },
  ],
  childRequirements: {
    message: "Only ContactBlock component are allowed",
    query: {
      "component.name": {
        $in: [ContactBlockComponent.name],
      },
    },
  },
  defaultChildren: [
    {
      "@type": "@builder.io/sdk:Element",
      component: {
        name: ContactBlockComponent.name,
      },
    },
  ],
};
